import React, { Component, createRef } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import Spinner from './Spinner';

import Header from './Header';

class AssetEdit extends Component {
  constructor(props) {
    super(props);
    this.nameInput = createRef();
    this.descInput = createRef();
    this.previewInput = createRef();
    this.downloadLinkInput = createRef();
  }

  onSubmit = e => {
    e.preventDefault();
    const { asset, firestore, history } = this.props;
    const updatedAset = {
      name: this.nameInput.current.value,
      desc: this.descInput.current.value,
      preview: this.previewInput.current.value,
      downloadLink: this.downloadLinkInput.current.value,
    };

    firestore.update({ collection: 'assets', doc: asset.id }, updatedAset).then(history.push('/members'));
  };

  render() {
    const { asset } = this.props;

    if (asset) {
      return (
        <div>
          <Header title="Izmjeni asset" img="/images/gallery/2013/074.jpg" />
          <section>
            <div className="container">
              {/* <div className="row">
              <div className="col-lg-6 mx-auto text-center">
                <h2 className="h1">naslov</h2>
                <div className="u-h-4 u-w-50 bg-primary rounded mt-4 u-mb-40 mx-auto" />
                <p>opis sta radimo i kako</p>
              </div>
            </div> */}
              <div className="row">
                <div className="col-md-12 text-center mt-5">
                  <form onSubmit={this.onSubmit}>
                    <div className="row">
                      <div className="col-md-12">
                        {/* <label htmlFor="name">Naziv</label> */}
                        <input
                          type="text"
                          className="form-control u-rounded-50 p-3 u-mb-30"
                          name="name"
                          placeholder="Naziv"
                          required
                          ref={this.nameInput}
                          defaultValue={asset.name}
                        />
                      </div>
                      {/* <label htmlFor="name">Opis</label> */}
                      <div className="col-md-12">
                        <input
                          type="text"
                          className="form-control u-rounded-50 p-3 u-mb-30"
                          name="desc"
                          placeholder="Opis"
                          required
                          ref={this.descInput}
                          defaultValue={asset.desc}
                        />
                      </div>
                      {/* <label htmlFor="name">Preview</label> */}
                      <div className="col-md-12">
                        <input
                          type="text"
                          className="form-control u-rounded-50 p-3 u-mb-30"
                          name="preview"
                          placeholder="Preview"
                          required
                          ref={this.previewInput}
                          defaultValue={asset.preview}
                        />
                      </div>
                      {/* <label htmlFor="name">Download Link</label> */}
                      <div className="col-md-12">
                        <input
                          type="text"
                          className="form-control u-rounded-50 p-3 u-mb-30"
                          name="downloadLink"
                          placeholder="Download Link"
                          required
                          ref={this.downloadLinkInput}
                          defaultValue={asset.downloadLink}
                        />
                      </div>
                    </div>
                    <button className="btn btn-rounded btn-primary" type="submit">
                      IZMJENI ASSET
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      );
    }
    return <Spinner />;
  }
}

export default compose(
  firestoreConnect(props => [
    {
      collection: 'assets',
      storeAs: 'asset',
      doc: props.match.params.id,
    },
  ]),
  connect(({ firestore: { ordered } }, props) => ({
    asset: ordered.asset && ordered.asset[0],
  }))
)(AssetEdit);



// WEBPACK FOOTER //
// ./src/components/AssetEdit.js